import { baseURL } from './baseUrl';

export const apiGetCareersData = async () => {
    const response = await baseURL.get(`download-careers-csv`);
    return response.data;
};
